module.exports = __webpack_public_path__ + "static/multiplePagesYes-83af992f36ad745c39efabf531b07509.png";